import { useRef } from 'react';
import Input from '../../inputs/Input';

interface MultiInputTableBodyProps<T> {
  items: T[];
  keyField: keyof T;
  dataField: keyof T;
  rowTitleField: keyof T;
  rowTitleSubfield?: keyof T;
  textField?: string[];
  onChange: (id: number, field: string, value: string) => void;
}
const MultiInputTableBody = <T,>({
  items,
  keyField,
  dataField,
  rowTitleField,
  rowTitleSubfield,
  textField = [],
  onChange,
}: MultiInputTableBodyProps<T>) => {
  const inputRefs = useRef<HTMLInputElement[][]>([]);

  const handleKeyDown =
    (rowIndex: number, colIndex: number) =>
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault();

        const rowCount = items.length;
        const colCount = Object.keys(
          items[0][dataField] as Record<string, string | null>
        ).length;

        let nextRow = rowIndex + 1;
        let nextCol = colIndex;

        if (nextRow >= rowCount) {
          nextRow = 0;
          nextCol = colIndex + 1;
          if (nextCol >= colCount) {
            nextCol = 0;
          }
        }

        const nextInput = inputRefs.current[nextRow]?.[nextCol];
        nextInput?.focus();
      }
    };

  return (
    <tbody>
      {items &&
        items?.map((item, rowIndex) => {
          const keyValue = item[keyField];
          const dataValue = item[dataField] as Record<string, string | null>;
          const rowTitle = item[rowTitleField];
          const rowTitleSub = rowTitleSubfield ? item[rowTitleSubfield] : null;
          // 行用のref配列を初期化
          if (!inputRefs.current[rowIndex]) inputRefs.current[rowIndex] = [];

          return (
            <tr key={Number(keyValue)}>
              <td>{String(rowTitle)}</td>
              {rowTitleSub && <td>{String(rowTitleSub)}</td>}
              {dataValue &&
                Object.entries(dataValue)?.map(([field, value], colIndex) => (
                  <td key={field}>
                    {textField.includes(field) ? (
                      <span>{value ? String(value) : ''}</span>
                    ) : (
                      <Input
                        value={value ?? ''}
                        onChange={(e) =>
                          onChange(Number(keyValue), field, e.target.value)
                        }
                        ref={(el) => {
                          if (el && !inputRefs.current[rowIndex].includes(el)) {
                            inputRefs.current[rowIndex][colIndex] = el;
                          }
                        }}
                        onKeyDown={handleKeyDown(rowIndex, colIndex)}
                      />
                    )}
                  </td>
                ))}
            </tr>
          );
        })}
    </tbody>
  );
};

export default MultiInputTableBody;
